//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TaskDescription from '@/components/tasks/TaskDescription'
import SingleTaskTitle from '@/components/tasks/SingleTaskTitle'
import RequiredSkills from '@/components/tasks/RequiredSkills'
import TaskDetails from '@/components/tasks/TaskDetails'
import SeoMethods from '@/mixins/SeoMethods'
import moment from 'moment'
import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'
import ShareButtons from '@/components/ui/ShareButtons'
import PostJobLink from '@/components/tasks/PostJobLink'
import ApplyForTaskButton from '@/components/tasks/ApplyForTaskButton'
import FetchTask from '@/mixins/FetchTask'
import NotFoundError from '@/components/common/NotFoundError'
import WinglioButton from '@/components/tasks/WinglioButton'
import TaskLikes from '@/components/tasks/TaskLikes'

export default {
  name: 'SingleTask',
  components: {
    TaskLikes,
    WinglioButton,
    NotFoundError,
    ApplyForTaskButton,
    PostJobLink,
    TaskDescription,
    SingleTaskTitle,
    RequiredSkills,
    TaskDetails,
    ShareButtons
  },
  mixins: [FetchTask, SeoMethods, AxiosErrorHandler],
  data () {
    return {
      loadingApplication: false
    }
  },
  head () {
    return this.buildTags(this.task?.title, this.task?.description, this.task?.owner?.avatar)
  },
  computed: {
    taskUrl () {
      return `tasks/${this.task?.slug}/${this.task?.id}`
    },
    invitationId () {
      return this.$route.query.invitationId ? parseInt(this.$route.query.invitationId, 10) : null
    }
  },
  async mounted () {
    if (this.$auth.loggedIn && this.$store.getters['user/isFreelancer']) {
      try {
        this.loadingApplication = true
        await this.$store.dispatch(
          'freelancerApplications/loadTaskApplication', parseInt(this.$route.params.id, 10)
        )
        this.loadingApplication = false
      } catch (err) {
        this.loadingApplication = false
        await this.handleError(err)
      }
    }
  },
  destroyed () {
    this.$store.commit('freelancerApplications/deselectApplication')
    this.$store.commit('tasks/deselectTask')
  },
  jsonld () {
    const jobTypeMapping = {
      fulltime: 'FULL_TIME',
      parttime: 'PART_TIME',
      onetime: 'CONTRACTOR'
    }
    const data = {
      '@context': 'https://schema.org',
      '@type': 'JobPosting',
      title: this.task?.title,
      description: this.task?.description,
      identifier: {
        '@type': 'PropertyValue',
        name: 'CryptoTask',
        value: this.task?.id
      },
      datePosted: moment(this.task?.createdAt).format('YYYY-MM-DD'),
      employmentType: jobTypeMapping[this.task?.type],
      hiringOrganization: {
        '@type': 'Organization',
        name: this.task?.owner?.name,
        logo: this.getImageUrl(this.task?.owner?.avatar)
      },
      baseSalary: {
        '@type': 'MonetaryAmount',
        currency: 'USD',
        value: this.task?.price
      }
    }

    if (this.task?.location === 'remote') {
      data.jobLocationType = 'TELECOMMUTE'
    } else {
      data.jobLocation = {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          addressLocality: this.task?.owner?.location
        }
      }
    }

    return data
  }
}
